import thunk from 'redux-thunk'
import { applyMiddleware, combineReducers, createStore } from 'redux'

import messagesReducer from './messages'
import loginReducer from './login/loginReducer'
import mainReducer from './main/mainReducer'
import umkdReducer from './umkd/umkdReducer'
import settingReducer from './settings/settingReducer'
import portfolioReducer from './portfolio/portfolioReducer'
import rpdReducer from './rpd/rpdReducer'

let reducers = combineReducers({
    msg: messagesReducer,
    login: loginReducer,
    main: mainReducer,
    umkd: umkdReducer,
    settings: settingReducer,
    portfolio: portfolioReducer,
    rpd: rpdReducer
})

export type AppStateType = ReturnType<typeof reducers>
export const store = createStore(reducers, applyMiddleware(thunk))

// @ts-ignore
window._store = store